// extracted by mini-css-extract-plugin
export default {"container":"AddressQRCode_container__+u+ix","logo":"AddressQRCode_logo__BF6i6"};